import { Injectable } from '@angular/core';
import {
  NgbDate,
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment'; // Import moment
import * as momenttime from 'moment-timezone';
import { Sale } from 'src/app/models/sales/sales.model';
@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
  private isUSTimezone: boolean = true;
  private dateSeperator = '/';
  constructor() {
    super();
  }
  public setIsUSTimeZone(lotOrHipText: string) {
    if (lotOrHipText === 'HIP') {
      this.isUSTimezone = true;
    } else {
      this.isUSTimezone = false;
    }
  }
  

  parse(value: string): NgbDateStruct | null {
    // Implement your date parsing logic based on the timezone condition
    if (this.isUSTimezone) {
      // Parse MM-dd-yyyy format
      const parts = value.trim().split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[2], 10);
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);

        return { year, month, day };
      }
    } else {
      // Parse dd-MM-yyyy format
      const parts = value.trim().split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[2], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[0], 10);
        return { year, month, day };
      }
    }

    return null; // Return null if parsing fails
  }

  getDateForModel(date: NgbDate): string {
    if (date.day && date.month && date.year) {
      var formatedDate = `${date.year}-${date.month
        .toString()
        .padStart(2, '0')}-${date.day.toString().padStart(2, '0')}T00:00:00.000Z`;
      return formatedDate;
    }
    return "";
  }

  format(date: NgbDateStruct | null): string {
    if (date === null) {
      return '';
    }
    // Format the date based on the timezone condition
    if (this.isUSTimezone) {
      return `${date.month.toString().padStart(2, '0')}${
        this.dateSeperator
      }${date.day.toString().padStart(2, '0')}${this.dateSeperator}${
        date.year
      }`;
    } else {
      return `${date.day.toString().padStart(2, '0')}${
        this.dateSeperator
      }${date.month.toString().padStart(2, '0')}${this.dateSeperator}${
        date.year
      }`;
    }
  }

  getMomentDateTimeFormat() {
    return !this.isUSTimezone ? 'DD/MM/yyyy h:mm a' : 'MM/DD/yyyy h:mm a';
  }
  getMomentLongDateTimeFormat() {
    return !this.isUSTimezone ? 'DD MMM, yyyy h:mm a' : 'MMM DD, yyyy h:mm a';
  }
  getLongDateTimeFormat() {
    return !this.isUSTimezone ? 'dd MMM, yyyy h:mm a' : 'MMM dd, yyyy h:mm a';
  }
  getLongDateFormat() {
    return !this.isUSTimezone ? 'dd MMM, yyyy' : 'MMM dd, yyyy';
  }
  getDateFormat() {
    return !this.isUSTimezone ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
  }
  getDefaultDateTimeFormat(longFormat: boolean) {
    return longFormat ? 'MMM dd, yyyy h:mm a' : 'MM/dd/yyyy h:mm a';
  }

  getDateFormatForSale(sale: Sale, longFormat: boolean) {
    return sale.lotOrHipText?.toLowerCase() === 'lot'
      ? longFormat
        ? 'dd MMM, yyyy'
        : 'dd/MM/yyyy'
      : longFormat
      ? 'MMM dd, yyyy'
      : 'MM/dd/yyyy';
  }

  getDateFormatForSaleWithTime(sale: Sale, longFormat: boolean) {
    return sale.lotOrHipText?.toLowerCase() === 'lot'
      ? longFormat
        ? 'dd MMM, yyyy h:mm a'
        : 'dd/MM/yyyy h:mm a'
      : longFormat
      ? 'MMM dd, yyyy h:mm a'
      : 'MM/dd/yyyy h:mm a';
  }

  getDateInTimezone(formatedDateString: string, timezone: string) {
    const userTimeZone = momenttime.tz.guess();
    // Create a moment object and set the timezone without conversion
    const dateWithTimezone = moment
      .tz(formatedDateString, timezone)
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    return dateWithTimezone;
  }
  getISODateInTimezone(isoDateString: string, timezone: string) {
    const userTimeZone = momenttime.tz.guess();
    const rex = /([+-]\d{2}:\d{2})$/;
    // Parse the ISO date string and convert it to the target timezone
    const dateWithTimezone = moment(isoDateString.replace(rex, ''))
      .tz(timezone, true)
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    return dateWithTimezone;
  }

  getISODate(isoDateString: string) {
    const userTimeZone = momenttime.tz.guess();
    const rex = /([+-]\d{2}:\d{2})$/;
    // Parse the ISO date string and convert it to the target timezone
    const dateWithTimezone = moment(isoDateString.replace(rex, '')).format(
      'YYYY-MM-DDTHH:mm:ss'
    );

    return dateWithTimezone;
  }
  static getDateFormatForSale(sale: Sale, longFormat: boolean) {
    return sale.lotOrHipText?.toLowerCase() === 'lot'
      ? longFormat
        ? 'dd MMM, yyyy'
        : 'dd/MM/yyyy'
      : longFormat
      ? 'MMM dd, yyyy'
      : 'MM/dd/yyyy';
  }
}
